import { ApiClient } from "lib/utils/client/apiClient"

export const adminDetails = async () => {
    return ApiClient('/admin/details', {
        method: 'GET',
    });
};

/**
 * Update profile picture
 * PATCH /auth/upload-profile-picture
 */
export const profileImageUpdate = async (data: FormData) => {
    return ApiClient('/auth/upload-profile-picture', {
        method: 'PATCH',
        body: data,
    });
};

/**
 * Change password
 * PATCH /auth/change-password
 */
export const passwordUpdate = async (data: { oldPassword: string, newPassword: string }) => {
    return ApiClient('/auth/change-password', {
        method: 'PATCH',
        body: JSON.stringify(data),
    });
};

/**
 * Update admin profile details
 * PATCH /auth/update-profile
 */
export const updateAdminDetails = async (data: { firstName?: string, lastName?: string, email?: string, department?: string }) => {
    return ApiClient('/auth/update-profile', {
        method: 'PATCH',
        body: JSON.stringify(data),
    });
};
